import { mainBackendApi } from '@/services'
import type { DepositAddress, GenerateAddressRequest } from '@/models/DepositAddress'

export const DepositAddressService = mainBackendApi.injectEndpoints({
	endpoints: build => ({
		getAddresses: build.query<DepositAddress[], void>({
			query: () => ({
				url: '/client/deposit-address/',
				method: 'GET',
			}),
			providesTags: ['DepositAddress'],
		}),
		generateAddress: build.mutation<DepositAddress, GenerateAddressRequest>({
			query: (body) => ({
				url: '/client/deposit-address/',
				method: 'POST',
				body,
			}),
			invalidatesTags: ['DepositAddress'],
		}),
	}),
})
